<div class="d-flex align-items-center justify-content-center home-register">
  <div class="container">
    <div class="row justify-content-center">
      <div class="card border-0 border-card">
        <div class="card-body p-3">
          <div class="mb-4 text-center">
            <h1 class="login-title">Join Us</h1>
            <p class="login-smalltext">Create your account</p>
          </div>

          <div class="d-flex justify-content-center mb-4">
            <div class="btn-group" role="group">
              <input type="radio" class="btn-check" name="roleToggle" id="btnJobSeeker" autocomplete="off"
                     [checked]="!isEmployer" (change)="toggleRole('user')">
              <label class="btn btn-outline-primary" for="btnJobSeeker">Job Seeker</label>

              <input type="radio" class="btn-check" name="roleToggle" id="btnEmployer" autocomplete="off"
                     [checked]="isEmployer" (change)="toggleRole('employer')">
              <label class="btn btn-outline-primary" for="btnEmployer">Employer</label>
            </div>
          </div>

          <form (ngSubmit)="onRegister()">

            @if (isEmployer) {
              <div class="mb-4">
                <label for="companyName" class="form-label label-text">Company Name</label>
                <input type="text" id="companyName" class="form-control form-control-custom form-field"
                       [(ngModel)]="companyName" name="companyName" required />
              </div>

              <div class="mb-4">
                <label for="companyDescription" class="form-label label-text">Company Description</label>
                <textarea id="companyDescription" class="form-control form-control-custom form-field"
                          [(ngModel)]="companyDescription" name="companyDescription" required></textarea>
              </div>

              <div class="mb-4">
                <label for="companyWebsite" class="form-label label-text">Website (Optional)</label>
                <input type="url" id="companyWebsite" class="form-control form-control-custom form-field"
                       [(ngModel)]="companyWebsite" name="companyWebsite" />
              </div>
            }

            @if (!isEmployer) {
              <div class="row">
                <div class="col-md-6 mb-4">
                  <label for="firstName" class="form-label label-text">First Name</label>
                  <input type="text" id="firstName" class="form-control form-control-custom form-field"
                         [(ngModel)]="firstName" name="firstName" required />
                </div>

                <div class="col-md-6 mb-4">
                  <label for="lastName" class="form-label label-text">Last Name</label>
                  <input type="text" id="lastName" class="form-control form-control-custom form-field"
                         [(ngModel)]="lastName" name="lastName" required />
                </div>
              </div>
            }

            <div class="mb-4">
              <label for="email" class="form-label label-text">Email address</label>
              <input type="email" id="email" class="form-control form-control-custom form-field"
                     [(ngModel)]="email" name="email" required />
            </div>

            <div class="mb-4">
              <label for="password" class="form-label label-text">Password</label>
              <input type="password" id="password" class="form-control form-control-custom form-field"
                     [(ngModel)]="password" name="password" required />
            </div>

            <div class="mb-4">
              <label for="confirmPassword" class="form-label label-text">Confirm Password</label>
              <input type="password" id="confirmPassword" class="form-control form-control-custom form-field"
                     [(ngModel)]="confirmPassword" name="confirmPassword" required />
            </div>

            <div class="d-grid mt-4">
              <button type="submit" class="btn login-btn" [disabled]="loading">
                {{ loading ? 'Registering...' : 'Register' }}
              </button>
            </div>

            <div class="mt-3 text-center">
              @if (error) {
                <p class="text-danger fw-bold mb-0">{{ error }}</p>
              }
              @if (success) {
                <p class="text-success fw-bold mb-0">{{ success }}</p>
              }
            </div>

          </form>

          <hr class="line mt-4">

          <div class="mt-4">
            <p class="smalltext-center">Already have an account? <a href="/login" class="smalltext-center underline">Login</a></p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
